import { useEffect, useRef } from "react";
interface ContextMenuProps {
    xPos: number;
    yPos: number;
    onEdit: () => void;
    onDelete: () => void;
    closeMenu: () => void;
    }

const MenuUpdateDelete = ({
  xPos,
  yPos,
  onEdit,
  onDelete,
  closeMenu,
}: ContextMenuProps) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        closeMenu(); // Ferme le menu si on clique à l'extérieur
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closeMenu]);

  return (
    <div
      className="absolute border border-grey shadow-lg z-10 bg-grey rounded-md w-28"
      style={{ top: yPos, left: xPos }}
      ref={menuRef}
    >
      <button
        className="block w-full text-left px-4 py-2 hover:font-bold text-white cursor-pointer"
        onClick={onEdit}
      >
        Modifier
      </button>

      <button
        className="block w-full text-left px-4 py-2 hover:font-bold text-white cursor-pointer"
        onClick={onDelete}
      >
        Supprimer
      </button>
    </div>
  );
};

export default MenuUpdateDelete;
